import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App);

// NEW 
import router from '@/router/index';
app.use(router);

import store from '@/store/index';
app.use(store);

import i18n from '@/i18n/index';
app.use(i18n);

import BootstrapVue from 'bootstrap-vue-3';
import '@/assets/css/styles.css'; //  Using our own css in src/assets/css/styles.css
// import 'leaflet/dist/leaflet.css';
app.use(BootstrapVue);

import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(fab);
library.add(fas);
library.add(far);
app.component('fa', FontAwesomeIcon);


import JsonCSV from 'vue-json-csv'
app.component('downloadCsv', JsonCSV)

import moment from 'moment'
app.config.globalProperties.$moment = moment;


import Toast from 'vue-toastification';
// Import the necessary CSS
import 'vue-toastification/dist/index.css';
const options = {
	// You can set your default options here
	timeout: 3000,
};
app.use(Toast, options);

import { VueSpinnersPlugin } from 'vue3-spinners';
app.use(VueSpinnersPlugin);

// Globally
import VueCollapsiblePanel from '@dafcoe/vue-collapsible-panel'
app.use(VueCollapsiblePanel)
// Stylesheet
import '@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css'

import VueSignaturePad from 'vue-signature-pad';
app.use(VueSignaturePad)

app.mount('#app')
